import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import Container from '@material-ui/core/Container';
import Box from '@mui/material/Box';
import Button from '@material-ui/core/Button';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import TextField from '@material-ui/core/TextField';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
//import CardHeader from '@material-ui/core/CardHeader';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import MuiAlert from '@material-ui/lab/Alert';
import Paper from '@mui/material/Paper';
import { Redirect } from 'react-router-dom';
import Spinner from 'react-bootstrap/Spinner'

import * as actions from "../store/actions";
import * as actionTypes from "../store/actions/actionTypes";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function AdminMessage(props){

    const [message, setMessage] = useState("");

    useEffect(() => {
        console.log('inside message');
        props.onGetMessage(props.token);
        props.onInitializeSaveMessage();
    }, []);

    //const handleToggle = ({target}) =>
    //    setPackagesList(s => ({ ...s, [target.name]: !s[target.name]}));

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    function validateForm() {
        return message.length > 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        console.log("login", message);

        const data = {
            message: message

        };
        props.onSaveMessage(props.token, data);
    }

    let saveMessageRedirect = null;
    if(props.isSuccessSaveMessage){
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_SUCCESS, message: 'Message saved.'});
        saveMessageRedirect = <Redirect to="/" />
    }

    let displayError = null;
    if (props.isErrorSaveMessage){
        //displayError = <Alert variant="danger">{props.isErrorSaveMessage}</Alert>
        props.onDisplaySnackbar({type: actionTypes.SNACKBAR_TYPE_ERROR, message: 'Error saving message.'});
    }

    return (
        <Container>
            {saveMessageRedirect}

            <Grid container spacing={2}>
                <Grid item md={12} xs={12}>
                    <Alert severity="info">{props.currentMessage}</Alert>
                </Grid>

                <Grid item md={12} xs={12}>
                    <Paper elevation={5}>
                        <Card>
                            <CardHeader
                                title="Update Panel Message"
                                titleTypographyProps={{
                                    fontSize: 17,
                                    fontWeight: 'bold'
                                }}
                            />
                            <Divider variant="middle" />
                            <CardContent>
                                <form>
                                    <FormGroup row>
                                        <FormControl fullWidth>
                                            <TextField
                                                id="message"
                                                value={message}
                                                label="Enter message"
                                                onChange={e => setMessage(e.target.value)}
                                                type="text"
                                                fullWidth
                                            />
                                        </FormControl>
                                    </FormGroup>
                                </form>
                            </CardContent>
                            <CardActions>
                                <Button
                                    block
                                    disabled={!validateForm() || props.isLoadingSaveMessage}
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={handleSubmit}
                                    fullWidth
                                >
                                    {props.isLoadingSaveMessage
                                        ? spinner
                                        : 'Update'}
                                </Button>
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
            </Grid>
        </Container>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        onInitializeSaveMessage: () => dispatch(actions.initializeSaveMessage()),
        onGetMessage: (token) => dispatch(actions.getMessage(token)),
        onSaveMessage: (token, data) => dispatch(actions.saveMessage(token, data)),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        currentMessage: state.getMessage.message,
        isLoadingSaveMessage: state.saveMessage.loading,
        isErrorSaveMessage: state.saveMessage.error,
        isSuccessSaveMessage: state.saveMessage.message

    }
};

export default connect(mapStateToProps,mapDispatchToProps)(AdminMessage);